export default __webpack_public_path__ + "static/media/Foto galerija 6.77ba3b0d.jpg";